import { Checkbox, Tooltip } from "@mui/material";
import React, { useContext, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import api from "../../app/api";
import Loader from "../../components/Loader";
import Screen from "../../components/Screen";
import SubmitButton from "../../components/SubmitButton";
import { DeleteAlert } from "../../components/Swal Alert";
import Table from "../../components/Table";
import { convertToLocal } from "../../config/functions";
import { keys } from "../../config/keys";
import { PoliciesContext } from "../../hooks/policiesContext";
import useAlert from "../../hooks/useAlert";
import useAuth from "../../hooks/useAuth";
import { deleteProposal, setProposal } from "../proposals/slice";

const FilesList = () => {
    const [deleteLoading, setDeleteLoading] = useState(null);
    const [loading, setloading] = useState(false);
    const [alerts, setAlerts] = useState([])
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const { showAlert } = useAlert()
    const getData = async () => {
        setloading("initial");
        try {
            let response = await api.get(`/alert/`, {
                params: {
                    page,
                    limit,
                }
            });
            if(response.data?.status){
                setAlerts(response.data?.result)
            }else {
                showAlert(response.data.message, "danger");
            }
        } catch (err) {
            const message = err.response
                ? err.response.data?.message
                    ? err.response.data?.message
                    : err.response.data
                : err;
            showAlert(message, "danger");
        } finally {
            setloading(null);
        }
    };
    const removeMail = async (id) => {
        if (!(await DeleteAlert())) return;
        setDeleteLoading(id)
        try {
            let response = await api.delete(`/alert/deleteAlert?_id=${id}`);
            if (response.data?.status) {
                showAlert(response?.data?.message, "success")
                getData()
            } else {
                showAlert(response?.data?.message, "danger")
            }
        } catch (error) {

        } finally {
            setDeleteLoading(null)
        }
    }
    const { isAdmin } = useAuth();

    const labels = [
        "#",
        "Title",
        "Description",
        "Type",
        "createdAt",
        "Actions",
    ].filter((item) => item);
    const data = useMemo(() => {
        if (!alerts || alerts.length === 0) return [];
        return alerts.map((item) => {
            return {
                data: item,
                fields: [
                    "#",
                    item?.title,
                    <td>{item?.description}</td>,
                    <td>{item?.type}</td>,
                    convertToLocal(item?.createdAt),
                    isAdmin && (
                        <div className="d-flex gap-3">
                            {item?._id == deleteLoading ? (
                                <div className="d-flex align-items-center justify-content-center ">
                                    <Loader loading={deleteLoading != null} color={"red"} />
                                </div>
                            ) : (
                                <i
                                    className="bi bi-trash text-danger"
                                    style={{ cursor: "pointer" }}
                                    onClick={() => removeMail(item._id)}
                                ></i>
                            )}

                        </div>
                    ),
                ].filter((it) => it),
            };
        });
    }, [alerts, deleteLoading, loading]);
    useEffect(() => {
        getData();
    }, [page, limit]);

    return (
        <Screen
            loading={loading == "initial"}

            flow={[
                { label: `System Alerts`, to: `/system-alerts` },
                { label: "Home", to: "/" },
                { label: `System Alerts`, to: `/system-alerts` },
            ]}
        >
            <Table
                labels={labels}
                data={data}
                page={page}
                limit={limit}
                setPage={setPage}
                setLimit={setLimit}
            // totalData={totalMsDocs}
            />
        </Screen>
    );
};

export default FilesList;
